import React from 'react';

function PlusMediumSVG() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 19C20 19.5523 20.4477 20 21 20C21.5523 20 22 19.5523 22 19V8C22 4.68629 19.3137 2 16 2H5C4.44772 2 4 2.44772 4 3C4 3.55229 4.44772 4 5 4H16C18.2091 4 20 5.79086 20 8V19Z" />
      <path d="M10 9.5C10.5523 9.5 11 9.94772 11 10.5V13H13.5C14.0523 13 14.5 13.4477 14.5 14C14.5 14.5523 14.0523 15 13.5 15H11V17.5C11 18.0523 10.5523 18.5 10 18.5C9.44772 18.5 9 18.0523 9 17.5V15H6.5C5.94772 15 5.5 14.5523 5.5 14C5.5 13.4477 5.94772 13 6.5 13H9V10.5C9 9.94772 9.44772 9.5 10 9.5Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 9C2 7.34315 3.34315 6 5 6H15C16.6569 6 18 7.34315 18 9V19C18 20.6569 16.6569 22 15 22H5C3.34315 22 2 20.6569 2 19V9ZM5 8C4.44772 8 4 8.44772 4 9V19C4 19.5523 4.44772 20 5 20H15C15.5523 20 16 19.5523 16 19V9C16 8.44772 15.5523 8 15 8H5Z"
      />
    </svg>
  );
}

export default PlusMediumSVG;
